<div class='agpr-article' [agprLoading]="isLoader">
    <agpr-scroll-panel #scrollPanel>
        <div class='agpr-article-form'>
            <input
                type="text"
                *ngIf = "!displayiFrame()"
                class="agpr-article-articleName"
                [maxlength]="256"
                pInputText
                [(ngModel)]="article.articleName"
                (ngModelChange)="onModelChanged()"
                [placeholder]="'Name Your Press Release'"
                [attr.disabled]="isDataEntryDisabled() ? '' : null"
            />
            <agpr-form-message *ngIf="(viewModel.showDraftErrors || viewModel.showPublishErrors) && (!article.articleName || article.articleName.trim()=='')">
                Press Release Name Required.
            </agpr-form-message>
            <div class="agpr-article-mainContent">
                <div class="agpr-article-contentSection">
                    <agpr-autosize-text-area
                        (ngModelChange)="onModelChanged()"
                        [(ngModel)]="article.headline"
                        [placeholder]="'Headline'"
                        [placeholderIcon]="'agpr-i-headline'"
                        [textAreaMaxLength]="256"
                        [textAreaCols]="100"
                        [isDisabled]="isDataEntryDisabled()"
                        [boxStyle]="{'font-size':'28px','font-weight':'bold','min-height': '45px', 'line-height':'normal'}"
                    >
                    </agpr-autosize-text-area>
                    <agpr-form-message *ngIf="viewModel.showPublishErrors && (!article.headline || article.headline.trim()=='')">
                        Headline Required.
                    </agpr-form-message>
                    <agpr-form-message *ngIf="viewModel.showPublishErrors && !validateUKHeadlineLength()">
                        Character Limit exceeded. Headlines for United Kingdom releases must not be more than 50 characters.
                    </agpr-form-message>
                </div>
                <div #companyLogo class="agpr-article-contentSection">
                    <agpr-browse-image
                        *ngIf="viewModel.showLogo"
                        (getImageUrl)="getBrowsedLogo($event)"
                        (getImageError)="showImageError($event)"
                        (doDelete)="deleteLogo($event)"
                        [showPlaceholder]="true"
                        [imageUrl]="article.companyLogo"
                        [showImageHtml]="showCompanyImageHtml"
                        [showImageInput]="showCompanyImageInput"
                        [placeholderName]="logoPlaceholder"
                        imageIcon="fa-regular fa-duotone fa-circle-star"
                        [showDeleteButton]="true"
                        [isDisabled]="isDataEntryDisabled()"
                        borderClass="agpr-browseImage-outerBlock agpr-browseImage-companyLogo"
                    >
                    </agpr-browse-image>
                </div>

                <div class="agpr-article-contentSection">
                    <agpr-autosize-text-area
                        [(ngModel)]="article.companyName"
                        [placeholder]="'Company Name'"
                        [maxlength]="256"
                        [placeholderIcon]="'fa-kit-duotone fa-agpr-outlet'"
                        [isMultiLine]="false"
                        [textAreaMaxLength]="256"
                        [isDisabled]="isDataEntryDisabled()"
                        (ngModelChange)="onModelChanged()"
                    >
                    </agpr-autosize-text-area>
                    <agpr-form-message *ngIf="viewModel.showPublishErrors && (!article.companyName || article.companyName.trim()=='')">
                        Company Name Required.
                    </agpr-form-message>
                </div>
                <div class="agpr-article-contentSection agpr-article-dateline">
                    <div class="agpr-article-datelineItem">
                        <agpr-autosize-text-area
                            [(ngModel)]="article.datelineLocation"
                            [placeholder]="'Dateline Location'"
                            [maxlength]="64"
                            [placeholderIcon]="'fa-regular fa-duotone fa-location-dot'"
                            [isMultiLine]="false"
                            [textAreaMaxLength]="64"
                            [isDisabled]="isDataEntryDisabled()"
                            (ngModelChange)="onModelChanged()"
                            [boxStyle]="{'font-weight':'bold'}"
                        >
                        </agpr-autosize-text-area>
                        <agpr-form-message *ngIf="viewModel.showPublishErrors && (!article.datelineLocation || article.datelineLocation.trim()=='')">
                            Dateline Location required.
                        </agpr-form-message>
                    </div>
                    <div class="agpr-article-datelineItem">
                        <agpr-news-date-picker
                            [(ngModel)]="article.datelineDate"
                            [placeholderIcon]="'fa-duotone fa-regular fa-calendar-range'"
                            [placeholder]="'Dateline Date'"
                            [isDisabled]="isDataEntryDisabled()"
                            (ngModelChange)="onModelChanged()"
                        >
                        </agpr-news-date-picker>
                        <agpr-form-message *ngIf="viewModel.showPublishErrors && (!article.datelineDate)">
                            Dateline Date required.
                        </agpr-form-message>
                    </div>
                </div>
                <div
                    class="agpr-article-contentSection"
                    *ngIf="!displayiFrame()"
                >
                    <agpr-content-editable-box
                        [(ngModel)]="article.body"
                        [placeholder]="'Body'"
                        [placeholderIcon]="'fa-solid fa-align-left'"
                        [maxLength]="12000"
                        (ngModelChange)="onModelChanged()"
                        [isRetracted] = "isDataEntryDisabled()"
                        [maxHtmlContentLength]="bodyFormattedTextLimit"
                        htmlContentLimitExceedMessage = "Formatted character limit exceeded."
                    >
                    </agpr-content-editable-box>
                    <agpr-form-message *ngIf="viewModel.showPublishErrors && (!article.body || article.body.trim()=='')">
                        Body Required.
                    </agpr-form-message>
                </div>

                <div
                    *ngIf="article.bodyContents.length > 0 && !displayiFrame()"
                    class="agpr-article-bodyContents"
                >
                    <div #bodyComponent *ngFor="let bodyContent of article.bodyContents; let i = index" class="agpr-article-contentSection">
                        <agpr-browse-image
                            *ngIf="bodyContent.bodyContentType === BodyContentTypes.Image"
                            (getImageUrl)="getBrowsedImage($event, bodyContent)"
                            (getImageError)="showImageError($event)"
                            (doDelete)="deleteBodyContent(bodyContent)"
                            [showPlaceholder]="showImagePlaceholder"
                            [imageUrl]="bodyContent.bodyContent"
                            [showImageHtml]="!!bodyContent.bodyContent"
                            [showImageInput]="!bodyContent.bodyContent"
                            [showDeleteButton]="true"
                            [isDisabled]="isDataEntryDisabled()"
                            [showMoveButtons]="true"
                            [moveUpDisabled]="i <= 0"
                            [moveDownDisabled]="i >= article.bodyContents.length - 1"
                            (moveUp)="moveBodyContentUp(i)"
                            (moveDown)="moveBodyContentDown(i)"
                        >
                        </agpr-browse-image>
                        <agpr-content-editable-box
                            [(ngModel)]="bodyContent.bodyContent"
                            *ngIf = "bodyContent.bodyContentType === BodyContentTypes.Text"
                            [placeholder]="'Text'"
                            [placeholderIcon]="'fa-solid fa-align-left'"
                            [maxLength]="12000"
                            (ngModelChange)="onModelChanged()"
                            [isRetracted] = "isDataEntryDisabled()"
                            [showDelete] = "true"
                            (onDeleteClick)="deleteBodyContent(bodyContent)"
                            [showMoveButtons]="true"
                            [moveUpDisabled]="i <= 0"
                            [moveDownDisabled]="i >= article.bodyContents.length - 1"
                            (moveUp)="moveBodyContentUp(i)"
                            (moveDown)="moveBodyContentDown(i)"
                            [maxHtmlContentLength]="bodyFormattedTextLimit"
                            htmlContentLimitExceedMessage = "Formatted character limit exceeded."
                        >
                        </agpr-content-editable-box>
                        <agpr-video-input
                            [(ngModel)]="bodyContent.bodyContent"
                            *ngIf = "bodyContent.bodyContentType === BodyContentTypes.Video"
                            [placeholderIcon]="'fa-regular fa-duotone fa-video'"
                            [placeholder]="'Video'"
                            [invalidFormatMessage]="articleLocalization.invalidVideoFormatMessage"
                            (ngModelChange)="onModelChanged()"
                            [isDisabled] = "isDataEntryDisabled()"
                            [showDelete] = "true"
                            (deleteClick)="deleteBodyContent(bodyContent)"
                            [showMoveButtons]="true"
                            [moveUpDisabled]="i <= 0"
                            [moveDownDisabled]="i >= article.bodyContents.length - 1"
                            (moveUp)="moveBodyContentUp(i)"
                            (moveDown)="moveBodyContentDown(i)"
                        >
                        </agpr-video-input>
                    </div>
                </div>
            </div>

            <div
                class="agpr-article-optionalContent"
                *ngIf="!displayiFrame() && (viewModel.showAboutUs || viewModel.showContacts || viewModel.showLinks)"
            >
                <div class="ui-g">
                    <div 
                        class="ui-g-12 agpr-article-aboutUsBlock" 
                        *ngIf="viewModel.showAboutUs" 
                        #aboutUs>
                        <h2
                            class="agpr-article-optionalContentHeading"
                            *ngIf="article.aboutUs"
                        >
                            About Us
                        </h2>
                        <agpr-content-editable-box
                            [(ngModel)]="article.aboutUs"
                            (onDeleteClick)="deleteAboutUs();"
                            [showDelete]="true"
                            [placeholderIcon]="'fa-regular fa-duotone fa-screen-users'"
                            [placeholder]="'About Us'"
                            [boxStyle]="{'min-height':'100px', 'background':'#fff'}"
                            [maxLength]="5000"
                            (ngModelChange)="onModelChanged()"
                        >
                        </agpr-content-editable-box>
                    </div>

                    <div class="ui-g-12" *ngIf="viewModel.showContacts" #contacts>
                        <h2
                            class="agpr-article-optionalContentHeading"
                            *ngIf="((contactsDataSource.all() | async)?.length > 0)"
                        >
                            Contacts
                        </h2>
                        <agpr-contacts
                            [dataSource]="contactsDataSource"
                            [buttons]="contactButtons"
                            [maxContactItems]="3"
                            [localization]="contactLocalizations"
                            [isDisabled]="isDataEntryDisabled()"
                            [showDraftErrors]="contactsDraftErrors && viewModel.showDraftErrors"
                            [showImageNormalMode]="showImageNormalMode"
                            (controlDelete)="onContactControlDelete();"
                            (getImageError)="showImageError($event)"
                            (isContactDirtyChange) = "onModelChanged();checkForContactsEmailError();">
                        </agpr-contacts>
                        <agpr-form-message *ngIf="contactsDraftErrors && viewModel.showDraftErrors">
                            {{ articleLocalization.contactsEmailError }}
                        </agpr-form-message>
                    </div>

                    <div
                        class="ui-g-12"
                        *ngIf="viewModel.showLinks"
                        #links
                    >
                        <h2
                            class="agpr-article-optionalContentHeading"
                            *ngIf="(linksDataSource.all() | async)?.length > 0"
                        >
                            Links
                        </h2>
                        <agpr-links
                            [dataSource]="linksDataSource"
                            [buttons]="linkButtons"
                            [maxLinkItems]="3"
                            [isDisabled]="isDataEntryDisabled()"
                            (isLinkDirtyChange)= "onModelChanged()"
                            (controlDelete)="onLinkControlDelete();"
                            linkFormatErrorMessage="Invalid link format."
                        >
                        </agpr-links>
                    </div>


                </div>
            </div>

        </div>

        <iframe
            #frame
            [srcdoc]="lastNotificationBodySafeHtml"
            class="agpr-article-publishedContent"
            *ngIf = "displayiFrame()"
            scrolling="no"
            iframe-resizer
        >
        </iframe>

    </agpr-scroll-panel>

    <agpr-footer-action-bar
        [rightButtonGroup]="actionButtons"
        *ngIf = "displayFooterActionBar()">
    </agpr-footer-action-bar>
</div>
